import React from 'react';
import RoutesJS from './routes/routes.js';
import { LayoutProvider } from './LayoutContext'; // Ajuste o caminho conforme necessário
import LayoutEffect from './LayoutEffect'; // Ajuste o caminho conforme necessário
import Header from './components/header/Header.jsx';
import videoSource from '../src/components/assets/planos-de-saude-pme-empresarial-individual-com-o-melhor-preco-reembolso-carencia.mp4';

function App() {
  return (
    <LayoutProvider>
      <LayoutEffect /> {/* Este componente aplica os efeitos de layout */}
      <div className="h-100 flex-desktop">
        <Header isVideo={true} mediaSource={videoSource} />
        <div className="">
          <div className="app__wrapper container">
            <RoutesJS />
          </div>
        </div>
      </div>
    </LayoutProvider>
  );
}

export default App;
